<template>
  <div>
    <!-- 公司简介 -->
    <div class="cpy_info">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <center>
            <h4>公司简介</h4>
          </center>
        </div>
        <div v-html="contentData.cpyInfo" class="text item">
        </div>
      </el-card>
    </div>

  </div>
</template>
<script>
export default {
    data: function() {
        return {
            contentData:{}
        }
    },
    created: function() {
      this.initData();
    },
    methods: {
      initData() {
          var self = this;
          this.$http.get(self.globalUrl.cpyInfo).then(function(res) {
              if (res.data.code == 200000) {
                  self.contentData = res.data.data;
              }
          });
      },

    }
}
</script>
<style media="screen" lang="less">


.cpy_info{
  margin-top: 2px;
}


</style>



// WEBPACK FOOTER //
// cpyIntroduction.vue?eb958bc8